/**
 * Saves the source code in browser session storage
 *
 * @param {string} sourcecode
 *   The sourcecode
 */
const saveSourceCodeToSessionStorage = (sourcecode) => {
  sessionStorage.setItem("sourcecode", sourcecode);
};

export default saveSourceCodeToSessionStorage;
